import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import moment from "moment";
// Constants - Functions
import { WEB_SERVICE_MIMS } from "../../../config/constants";
import { formatTimeDifference } from "../../../config/functions";
import { getSessionsWithSomeHitOrError } from "../functions";
// Components
import { IndicatorDataDiv, IndicatorDataText } from "./styles";
import Loader from "../../loader";
import Axios from "../../../config/axios";
import PatientNavigation from "../../patientNavigation";
import MenuNavigation from "../sections/menuNavigation";
import Title from "../../title";
import SessionsHeader from "./sections/sessionsHeader";
import SessionsData from "./sections/sessionData";

const Sessions = () => {
  const [sessions, setSessions] = useState([]);
  // Loaders
  const [isLoadingSessions, setIsLoadingSessions] = useState(true);

  const { patientId } = useParams();
  const [t] = useTranslation("global");

  // Fetching sessions
  useEffect(() => {
    Axios("get", `${WEB_SERVICE_MIMS}/icu/get-sessions/${patientId}`)
      .then(({ data }) => {
        const sessionsWithSomeHitOrError = getSessionsWithSomeHitOrError(data);
        const sessionsGroupedByDate = sessionsWithSomeHitOrError.reduce((acc, session) => {
          const date = session.STARTING_DATE.split("T")[0];

          if (!acc[date]) {
            acc[date] = {
              date,
              minStartingDate: session.STARTING_DATE,
              maxEndingDate: session.ENDING_DATE,
              durationInSeconds: 0,
            };
          } else {
            acc[date].minStartingDate =
              session.STARTING_DATE < acc[date].minStartingDate ? session.STARTING_DATE : acc[date].minStartingDate;
            acc[date].maxEndingDate = session.ENDING_DATE > acc[date].maxEndingDate ? session.ENDING_DATE : acc[date].maxEndingDate;
          }

          acc[date].durationInSeconds = (new Date(acc[date].maxEndingDate) - new Date(acc[date].minStartingDate)) / 1000;

          return acc;
        }, {});

        const sessionsGroupedByDateArray = Object.values(sessionsGroupedByDate).sort((a, b) => new Date(b.date) - new Date(a.date));

        setSessions(sessionsGroupedByDateArray);
        setIsLoadingSessions(false);
      })
      .catch((error) => {
        console.log("Get sessions: ", error);
      });

    return () => {
      setSessions([]);
      setIsLoadingSessions(true);
    };
  }, [patientId]);

  const renderSessionsList = () => {
    return sessions.map((session, i) => {
      const sessionNumber = sessions.length - i;
      const date = moment(session.date).format("DD/MM/YYYY");
      const startTime = moment(session.minStartingDate).format("HH:mm");
      const endTime = moment(session.maxEndingDate).format("HH:mm");
      const totalTime = formatTimeDifference(session.minStartingDate, session.maxEndingDate);

      return (
        <SessionsData key={date} sessionNumber={sessionNumber} date={date} startTime={startTime} endTime={endTime} totalTime={totalTime} />
      );
    });
  };

  return (
    <>
      {isLoadingSessions ? (
        <Loader />
      ) : (
        <>
          <PatientNavigation patientId={patientId} section={"icu"} />
          <MenuNavigation />
          {!Boolean(sessions.length) ? (
            <IndicatorDataDiv>
              <IndicatorDataText>{t("rgsicu_noSessionsMessage")}</IndicatorDataText>
            </IndicatorDataDiv>
          ) : (
            <>
              <Title title={`${t("sessions")}`.toUpperCase()} marginBottom="10px" />
              <SessionsHeader />
              {renderSessionsList()}
            </>
          )}
        </>
      )}
    </>
  );
};

export default Sessions;
